import { Component, OnInit } from '@angular/core';
import { ToastService } from '../../../../services/toast.service';
import { Base } from '../../../../types/Base.type';
import { ClienteBasicoResponse } from '../../../../types/ClienteBasicoResponse.type';
import { Servidor } from '../../../../types/Servidor.type';
import { ClientesService } from '../../clientes/clientes/clientes.service';
import { BaseService } from './base.service';
import { ServidoresService } from './servidores.service';

@Component({
  selector: 'app-servidores',
  templateUrl: './servidores.component.html',
  styleUrl: './servidores.component.css'
})
export class ServidoresComponent implements OnInit {

  servidorDialog: boolean = false;
  servidor!: Servidor;
  enviadoServidor: boolean = false;
  
  baseDialog: boolean = false;
  base!: Base;
  enviadoBase: boolean = false;

  servidores!: Servidor[];

  clonedServidor: { [s: string]: Servidor } = {};
  clonedBase: { [s: string]: Base } = {};

  clientes!: ClienteBasicoResponse[];

  clienteSelecionado!: ClienteBasicoResponse;

  constructor(private servidoresService: ServidoresService, private baseService: BaseService, private toastService: ToastService, private clienteService: ClientesService) {}

  ngOnInit(){
    this.getServidores();
  }

  getServidores(){
    this.servidores = []
    
    this.servidoresService.getAll().subscribe((data) => {
      this.servidores = data;
    })
  }

  editar(servidor: Servidor){
    this.clonedServidor[servidor.id as string] = { ...servidor };
  }

  salvar(servidor: Servidor){
    this.servidoresService.post(servidor).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "Servidor salvo com sucesso");
        
      },
      error: (value) =>{
        this.toastService.erro("Erro", "Erro ao salvar: " + value.error);
      }
    });
  }

  cancelar(servidor: Servidor, index: number){
    this.servidores[index] = this.clonedServidor[servidor.id as string];
    delete this.clonedServidor[servidor.id as string];
  }

  desativar(servidor: Servidor){
    this.servidoresService.delete(servidor.id).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "Servidor desativado");
        this.getServidores();
      },
      error: (value) => {
        this.toastService.erro("Erro", "Erro ao desativar: " + value.error);
      }
        
    })
  }

  ativar(servidor: Servidor){
    var atualizado = { ...servidor}

    atualizado.ativo = true;

    this.servidoresService.put(atualizado).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "Servidor ativado");
        this.getServidores();
      },
      error: (value) => {
        this.toastService.erro("Erro", "Erro ao ativar: " + value)
        this.getServidores();
      },
    })

    
  }


  editarBase(base: Base){
    this.clonedBase[base.id as string] = { ...base };
  }

  salvarBase(base: Base){
    this.baseService.post(base).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "Base salvo com sucesso");
        
      },
      error: (value) =>{
        this.toastService.erro("Erro", "Erro ao salvar: " + value.error);
      }
    });
  }

  cancelarBase(base: Base, index: number){
    this.servidores[index] = this.clonedServidor[base.id as string];
    delete this.clonedServidor[base.id as string];
  }

  desativarBase(base: Base){
    this.baseService.delete(base.id).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "Base desativada");
        this.getServidores();
      },
      error: (value) => {
        this.toastService.erro("Erro", "Erro ao desativar: " + value.error);
      }
        
    })
  }

  ativarBase(base: Base){
    var atualizado = { ...base}

    atualizado.ativo = true;

    this.baseService.put(atualizado).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "Base ativada");
        this.getServidores();
      },
      error: (value) => {
        this.toastService.erro("Erro", "Erro ao ativar: " + value)
        this.getServidores();
      },
    })

    
  }

  abreDialogServidor(){
    this.servidor = {} as Servidor;
    this.enviadoServidor = false;
    this.servidorDialog = true;
    
  }

  escondeDialogServidor(){
   this.servidorDialog = false;
   this.enviadoServidor = false;
  }

  salvarServidor(){
    this.enviadoServidor = true;

    if(this.servidor.nome?.trim() && this.servidor.senha?.trim() && this.servidor.url?.trim() && this.servidor.usuario.trim()){
      this.servidoresService.post(this.servidor).subscribe({
        next: () => {
          this.toastService.sucesso("Sucesso", "Servidor criado com sucesso");
          this.servidorDialog = false;
          this.servidor = {} as Servidor;

          this.getServidores();
        },
        error: (value) => {
          this.toastService.erro("Erro", "Erro ao criar: " + value.error);
        }
      })

      
    }

    
  }



  abreBaseDialog(servidor: Servidor){
    // this.clienteSelecionado = {} as ClienteBasicoResponse
    // this.getClientes();
    this.servidor =  servidor;
    // this.base = {} as Base;
    // this.enviadoBase = false;
    // this.baseDialog = true;

    this.baseDialog = true;
  }

  escondeDialogBase(){
   this.baseDialog = false;
   this.enviadoBase = false;
   this.servidor = {} as Servidor;

   this.getServidores()
  }

  salvarBaseNova(){
    this.enviadoBase = true;

    if(this.base.nome?.trim() && this.clienteSelecionado.id != undefined && this.base.usuario?.trim() && this.base.senha?.trim()){
      alert('validado')
      // this.baseService.post(this.base).subscribe({
      //   next: () => {
      //     this.toastService.sucesso("Sucesso", "Base criada com sucesso");
      //     this.baseDialog = false;
      //     this.base = {} as Base;
      //     this.servidor = {} as Servidor;

      //     this.getServidores();
      //   },
      //   error: (value) => {
      //     this.toastService.erro("Erro", "Erro ao criar: " + value.error);
      //   }
      // })

      
    }

    
  }

  getClientes(){
    this.clienteService.getBasico().subscribe((data) => {
      this.clientes = data;
    })
  }



}
